import styled from 'styled-components'

import { helpers } from 'styles'

import { ButtonIcon } from 'components/Buttons'

export const FloatingMenuButton = styled(ButtonIcon)`
	display: none;

	@media only screen and (max-width: 750px) {
		display: block;
		position: absolute;
		z-index: 98;
		right: 32px;
		bottom: 32px;
		background-color: ${helpers.color.secondary};
		border-radius: 4px;
		padding: 8px;
		height: 52px;
		width: 52px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

		&:is(:focus-visible, :hover) {
			background-color: ${helpers.color.secondaryAccent};
		}
	}
`
